import { render, staticRenderFns } from "./blogOne.vue?vue&type=template&id=bce912d8&scoped=true&"
import script from "./blogOne.vue?vue&type=script&lang=js&"
export * from "./blogOne.vue?vue&type=script&lang=js&"
import style0 from "./blogOne.vue?vue&type=style&index=0&id=bce912d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce912d8",
  null
  
)

export default component.exports